import React from 'react';
import PropTypes from 'prop-types';
import purple from '@material-ui/core/colors/purple';
import { FulfillingBouncingCircleSpinner } from 'react-epic-spinners';
import { SpinnerWrapper } from '../../globalStyle';

const Loading = ({ small, color }) => (
  <SpinnerWrapper small={small}>
    <FulfillingBouncingCircleSpinner color={color} />
  </SpinnerWrapper>
);

Loading.defaultProps = {
  color: purple[500],
  small: false,
};

Loading.propTypes = {
  color: PropTypes.string,
  small: PropTypes.bool,
};

export default Loading;
